import { nsRentalFile } from '@/app/i18n/namespaces';

export const RENTAL_FILE_STATUS = {
    OPENED: { name: 'OPENED', entity: 'status.OPENED', namespace: nsRentalFile, variant: 'green' },
    CLOSED_WITH_DEBIT: { name: 'CLOSED_WITH_DEBIT', entity: 'status.CLOSED_WITH_DEBIT', namespace: nsRentalFile, variant: 'light-green' },
    CLOSED_NO_DEBIT: { name: 'CLOSED_NO_DEBIT', entity: 'status.CLOSED_NO_DEBIT', namespace: nsRentalFile, variant: 'gray' },
    CLOSED_EXPIRED: { name: 'CLOSED_EXPIRED', entity: 'status.CLOSED_EXPIRED', namespace: nsRentalFile, variant: 'orange' },
    ERROR_INITIALIZATION: { name: 'ERROR_INITIALIZATION', entity: 'status.ERROR_INITIALIZATION', namespace: nsRentalFile, variant: 'red' },
    UNKNOWN: { name: 'UNKNOWN', entity: 'status.UNKNOWN', namespace: nsRentalFile, variant: 'gray' }
};